import Glide from '@glidejs/glide'

export default function () {
    console.log('✅ glide-slider.js')
    if ( !document.querySelector('.slider') ) {
        return;
    }

    const sliderHero = new Glide('.hero-slider', {
        autoplay: 8000,
        type: 'carousel',
        perView: 1,
    })

    const sliderProducts = new Glide('.most-products', {
        autoplay: 8000,
        type: 'carousel',
        // animationDuration: 800,
        startAt: 0,
        perView: 4,
        breakpoints: {
            1900: {
                perView: 6,
                peek: {
                    before: 32,
                    after: 32,
                },
            },
            1680: {
                perView: 5,
                peek: {
                    before: 32,
                    after: 32,
                },
            },
            1280: {
                perView: 4,
                peek: {
                    before: 32,
                    after: 32,
                },
            },
            992: {
                perView: 3.2,
                peek: {
                    before: 16,
                    after: 16,
                },
            },
            768: {
                perView: 2.2,
                peek: {
                    before: 16,
                    after: 16,
                },
            },

            576: {
                perView: 1.2,
                peek: {
                    before: 8,
                    after: 8,
                },

            }
        },
    })
    const sliderProducts2 = new Glide('.most-products2', {
        autoplay: 8000,
        type: 'carousel',
        // animationDuration: 800,
        startAt: 0,
        perView: 4,
        breakpoints: {
            1900: {
                perView: 6,
                peek: {
                    before: 32,
                    after: 32,
                },
            },            
            1680: {
                perView: 5,
                peek: {
                    before: 32,
                    after: 32,
                },
            },            
            1280: {
                perView: 4,
                peek: {
                    before: 32,
                    after: 32,
                },
            },
            992: {
                perView: 3.2,
                peek: {
                    before: 16,
                    after: 16,
                },
            },
            768: {
                perView: 2.2,
                peek: {
                    before: 16,
                    after: 16,
                },
            },

            576: {
                perView: 1.2,
                peek: {
                    before: 8,
                    after: 8,
                },

            }
        },
    })

    sliderHero.mount()
    sliderProducts.mount()
    sliderProducts2.mount()
}
